module.exports = __webpack_public_path__ + "static/media/portfolio2.16799418.PNG";